// extracted by mini-css-extract-plugin
export var transportationsCountCell = "_2ff8b9910c93b7fea5f3a3c62d459476-css";
export var transportationsCountCellUnlockButton = "_1dd7edd48a591d5e93325efc555e2e82-css";